// Build-time settings (Vite env). Everything is optional: with nothing set, Studio runs in sample mode.

const env = import.meta.env;

export const config: { tenantId: string; clientId: string; apiScope: string; controlPlaneUrl: string; dataMode: "live" | "sample" } = {
  tenantId: (env.VITE_TENANT_ID as string | undefined)?.trim() || "",
  clientId: (env.VITE_CLIENT_ID as string | undefined)?.trim() || "",
  apiScope: (env.VITE_API_SCOPE as string | undefined)?.trim() || "",
  controlPlaneUrl: ((env.VITE_CONTROL_PLANE_URL as string | undefined) || "").replace(/\/+$/, ""),
  dataMode: (env.VITE_DATA_MODE as string | undefined) === "live" ? "live" : "sample",
};

/** VERA.exe: take live settings from vera.config.json, so turning VERA on needs no rebuild of the UI. */
export async function loadDesktopLiveConfig(bridge: { live?: () => Promise<{ live: boolean; controlPlaneUrl: string }> } | null | undefined) {
  if (!bridge?.live) return;
  try {
    const s = await bridge.live();
    if (s.controlPlaneUrl) config.controlPlaneUrl = s.controlPlaneUrl.replace(/\/+$/, "");
    if (s.live) config.dataMode = "live";
  } catch { /* stay in the honest team mode */ }
}

export const microsoftConfigured = Boolean(config.tenantId && config.clientId);
